export default __webpack_public_path__ + "static/media/011-Golden Retriever.927bd82c.svg";